"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/web.timers.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isHexColor = _interopRequireDefault(require("validator/lib/isHexColor"));

var _color = _interopRequireDefault(require("color"));

var _Sensor = require("@meepshop/context/lib/Sensor");

var _DecoratorsRoot = require("../layout/DecoratorsRoot");

var _propTypes2 = require("../constants/propTypes");

var _Logo = _interopRequireDefault(require("./Logo"));

var _SocialMedia = _interopRequireDefault(require("./SocialMedia"));

var _MenuList = _interopRequireDefault(require("./MenuList"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

require("./styles/index.less");

var styles = {
  "root": "meepshop-meep-ui__bottom-index__root",
  "menu": "meepshop-meep-ui__bottom-index__menu",
  "wrapper": "meepshop-meep-ui__bottom-index__wrapper",
  "logoWrapper": "meepshop-meep-ui__bottom-index__logoWrapper",
  "menuWrapper": "meepshop-meep-ui__bottom-index__menuWrapper",
  "socialMediaWrapper": "meepshop-meep-ui__bottom-index__socialMediaWrapper",
  "socialMediaIcon": "meepshop-meep-ui__bottom-index__socialMediaIcon",
  "link": "meepshop-meep-ui__bottom-index__link",
  "menuTitle": "meepshop-meep-ui__bottom-index__menuTitle",
  "submenuTitle": "meepshop-meep-ui__bottom-index__submenuTitle",
  "top4": "meepshop-meep-ui__bottom-index__top4",
  "mask": "meepshop-meep-ui__bottom-index__mask",
  "line": "meepshop-meep-ui__bottom-index__line",
  "slogan": "meepshop-meep-ui__bottom-index__slogan",
  "left": "meepshop-meep-ui__bottom-index__left",
  "right": "meepshop-meep-ui__bottom-index__right",
  "center": "meepshop-meep-ui__bottom-index__center"
};

var Bottom = function Bottom(props) {
  var _display$showLogo, _display$showSlogan, _display$showSocialMe;

  var fontSizeFromProps = props.fontSize,
      colors = props.colors,
      menu = props.menu,
      background = props.background,
      color = props.color,
      alignmentFromProps = props.alignment,
      display = props.display,
      hoverColor = props.hoverColor,
      _props$socialMediaLin = props.socialMediaLink,
      socialMediaLink = _props$socialMediaLin === void 0 ? {} : _props$socialMediaLin,
      slogan = props.slogan,
      mobileExpandType = props.mobileExpandType,
      _props$storeSetting = props.storeSetting,
      logoUrl = _props$storeSetting.logoUrl,
      mobileLogoUrl = _props$storeSetting.mobileLogoUrl;
  var showLogo = (_display$showLogo = display === null || display === void 0 ? void 0 : display.showLogo) !== null && _display$showLogo !== void 0 ? _display$showLogo : false;
  var showSlogan = (_display$showSlogan = display === null || display === void 0 ? void 0 : display.showSlogan) !== null && _display$showSlogan !== void 0 ? _display$showSlogan : false;
  var showSocialMedia = (_display$showSocialMe = display === null || display === void 0 ? void 0 : display.showSocialMedia) !== null && _display$showSocialMe !== void 0 ? _display$showSocialMe : false;
  var alignment = alignmentFromProps !== null && alignmentFromProps !== void 0 ? alignmentFromProps : 'center';
  var fontSize = fontSizeFromProps !== null && fontSizeFromProps !== void 0 ? fontSizeFromProps : 14;

  var _useSensorContext = (0, _Sensor.useSensorContext)(),
      isDesktop = _useSensorContext.isDesktop,
      isMobile = _useSensorContext.isMobile;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      openKeys = _useState2[0],
      setOpenKeys = _useState2[1];

  var resizeTimeout = (0, _react.useRef)(null);
  var isUnmounted = (0, _react.useRef)(false);
  var logo = isDesktop ? logoUrl : mobileLogoUrl;
  var resize = (0, _react.useCallback)(function () {
    clearTimeout(resizeTimeout.current);
    resizeTimeout.current = setTimeout(function () {
      if (!menu) return;
      var pages = menu.pages;
      setOpenKeys(isMobile ? [] : pages.map(function (_ref) {
        var pageId = _ref.id;
        return pageId;
      }));
    }, 100);
  }, [menu, isMobile]);
  (0, _react.useEffect)(function () {
    resize();
    window.addEventListener('resize', resize);
    return function () {
      isUnmounted.current = true;
      window.removeEventListener('resize', resize);
    };
  }, [resize]);
  if (!menu) return null;
  var pages = menu.pages,
      _menu$design = menu.design,
      opacity = _menu$design.opacity,
      design = (0, _objectWithoutProperties2["default"])(_menu$design, ["opacity"]);
  var normal = {
    color: color || colors[3],
    background: !background || !(0, _isHexColor["default"])(background || '') ? '#ffffff' : background
  };
  var lineColor = color ? "rgba(".concat(_color["default"].rgb(color).array(), ", 0.08)") : 'rgba(var(--color-rgb-3), 0.08)';

  var renderContent = function renderContent() {
    switch (alignment) {
      case 'left':
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(styles.wrapper, " ").concat(styles.left)
        }, (showLogo || showSlogan && slogan) && /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.logoWrapper
        }, showLogo && /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
          logo: logo,
          height: 48,
          storeName: design.storeName
        }), showSlogan && slogan && slogan.trim() !== '' && /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.slogan
        }, slogan)), (showLogo || showSlogan && slogan) && /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.line,
          style: {
            '--line-color': lineColor
          }
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.menuWrapper
        }, /*#__PURE__*/_react["default"].createElement(_MenuList["default"], {
          mobileExpandType: mobileExpandType,
          pages: pages,
          design: design,
          normal: normal,
          background: background,
          fontSize: fontSize,
          openKeys: openKeys,
          alignment: alignment,
          setOpenKeys: setOpenKeys,
          hoverColor: hoverColor
        }), showSocialMedia && /*#__PURE__*/_react["default"].createElement(_SocialMedia["default"], {
          socialMediaLink: socialMediaLink,
          hoverColor: hoverColor,
          color: color
        })));

      case 'right':
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(styles.wrapper, " ").concat(styles.right)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.logoWrapper
        }, showLogo && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
          logo: logo,
          height: 48,
          storeName: design.storeName
        })), (showSlogan !== null && showSlogan !== void 0 ? showSlogan : true) && slogan && /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.slogan
        }, slogan), showSocialMedia && isDesktop && /*#__PURE__*/_react["default"].createElement(_SocialMedia["default"], {
          socialMediaLink: socialMediaLink,
          hoverColor: hoverColor,
          color: color
        })), (showLogo || showSlogan && slogan) && !isDesktop && /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.line,
          style: {
            '--line-color': lineColor
          }
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.menuWrapper
        }, /*#__PURE__*/_react["default"].createElement(_MenuList["default"], {
          mobileExpandType: mobileExpandType,
          pages: pages,
          design: design,
          normal: normal,
          hoverColor: hoverColor,
          background: background,
          fontSize: fontSize,
          openKeys: openKeys,
          alignment: alignment,
          setOpenKeys: setOpenKeys
        }), showSocialMedia && !isDesktop && /*#__PURE__*/_react["default"].createElement(_SocialMedia["default"], {
          socialMediaLink: socialMediaLink,
          hoverColor: hoverColor,
          color: color
        })));

      case 'center':
      default:
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(styles.wrapper, " ").concat(styles.center)
        }, (showLogo || showSlogan && slogan) && /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.logoWrapper
        }, showLogo && /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
          logo: logo,
          height: 48,
          storeName: design.storeName
        }), (showSlogan !== null && showSlogan !== void 0 ? showSlogan : true) && slogan && /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.slogan
        }, slogan)), (showLogo || showSlogan && slogan) && /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.line,
          style: {
            '--line-color': lineColor
          }
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: styles.menuWrapper
        }, /*#__PURE__*/_react["default"].createElement(_MenuList["default"], {
          mobileExpandType: mobileExpandType,
          pages: pages,
          design: design,
          normal: normal,
          hoverColor: hoverColor,
          background: background,
          fontSize: fontSize,
          openKeys: openKeys,
          alignment: alignment,
          setOpenKeys: setOpenKeys
        }), showSocialMedia && /*#__PURE__*/_react["default"].createElement(_SocialMedia["default"], {
          socialMediaLink: socialMediaLink,
          hoverColor: hoverColor,
          color: color
        })));
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, normal), {}, {
      background: background
    }),
    className: styles.root
  }, /*#__PURE__*/_react["default"].createElement("div", null, renderContent()));
};

Bottom.propTypes = {
  /** context */
  colors: _propTypes2.COLOR_TYPE.isRequired,

  /** props */
  alignment: _propTypes["default"].string,
  hoverColor: _propTypes["default"].string,
  socialMediaLink: _propTypes["default"].shape({}).isRequired,
  slogan: _propTypes["default"].string,
  background: _propTypes["default"].string,
  color: _propTypes["default"].string,
  fontSize: _propTypes["default"].number,
  showLogo: _propTypes["default"].bool,
  showSlogan: _propTypes["default"].bool,
  showSocialMedia: _propTypes["default"].bool,
  logo: _propTypes["default"].shape({}),
  designHeight: _propTypes["default"].number,
  handleLogoClick: _propTypes["default"].func,
  handleClick: _propTypes["default"].func,
  getUrl: _propTypes["default"].func,
  menu: _propTypes["default"].shape({
    pages: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes2.ID_TYPE.isRequired
    }).isRequired),
    design: _propTypes["default"].shape({}).isRequired
  }).isRequired
};

var _default = (0, _DecoratorsRoot.enhancer)(Bottom);

exports["default"] = _default;